export function useIsEmbed() {
  return useState("is-embed", () => false);
}
